import { WixDesignSystemsMaskingContext } from 'wix-design-systems-providers';
export var WixStyleReactMaskingContext = WixDesignSystemsMaskingContext;
//# sourceMappingURL=context.js.map